import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
// import { connect } from 'react-redux'
import { navigate } from "gatsby";
import { 
  EditOutlined, 
  SettingOutlined,UserOutlined ,
  ShopOutlined, 
  QuestionCircleOutlined, 
  LogoutOutlined,SettingFilled
} from '@ant-design/icons';
import { connect } from "react-redux"
import { Logout } from "../../../actions/Auth"

// import { signOut } from 'redux/actions/Auth';

const menuItem = [
	{
		title: "Edit Profile",
		icon: EditOutlined ,
		path: "/"
    },
    
    {
		title: "Account Setting",
		icon: SettingOutlined,
		path: "/"
    },
    {
		title: "Billing",
		icon: ShopOutlined ,
		path: "/"
	},
    {
		title: "Help Center",
		icon: QuestionCircleOutlined,
		path: "/"
	}
]

export const NavProfile = ({userName,companyName,logo,Logout}) => {
  const profileImg = "/img/avatars/thumb-1.jpg";
  const signOut=()=>{
    navigate('/auth')
      localStorage.removeItem('token')
      localStorage.removeItem('role_id')
      localStorage.removeItem('data')
      localStorage.removeItem('userName')
      localStorage.removeItem('yard')
      localStorage.removeItem('attention')
      Logout()
  }
  const OpenSettings=()=>{
    navigate('/settings')
  }
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={<UserOutlined style={{fontSize:25,marginLeft:7,marginTop:6}}/>} style={{minWidth:45}} />
          <div className="pl-3">
            <h4 className="mb-0" style={{overflowWrap: 'anywhere'}}>{userName}</h4>
            <span className="text-muted">{companyName}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {/* {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })} */}
            <Menu.Item key={menuItem.length+2} onClick={e => OpenSettings()}>
            <span>
              <SettingFilled className="mr-3"/>
              <span className="font-weight-normal">Settings</span>
            </span>
          </Menu.Item>
          <Menu.Item key={menuItem.length + 1} onClick={e => signOut()}>
            <span>
              <LogoutOutlined className="mr-3" style={{borderColor:'black'}}/>
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={<UserOutlined style={{fontSize:25,marginLeft:7,marginTop:6}}/>} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null, { Logout })(NavProfile)
